import React from 'react';

import { Button } from '@infoods/lifebase-ui';
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';
import { useToggle } from 'react-use';

import { HelpCenterWidget } from '../../containers/HelpCenterWidget/HelpCenterWidget';

const HelpCenterButton = () => {
  const [isPanelOpen, togglePanelOpen] = useToggle(false);

  return (
    <>
      <Button
        variant="text"
        color="secondary"
        size="small"
        startIcon={<HelpOutlineRoundedIcon />}
        onClick={() => togglePanelOpen(true)}
      >
        Help Center
      </Button>
      <HelpCenterWidget open={isPanelOpen} onClose={() => togglePanelOpen(false)} />
    </>
  );
};

export { HelpCenterButton };
